import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { Placement, PopupType } from './types';

import './pop-up.css';
import { usePatientProfileSettings } from '../ProfileBar/hooks';

const CareMapprPopup = ({
  show,
  onHide,
  title,
  titleIcon,
  children,
  type = PopupType.DEFAULT,
  placement = Placement.END,
  className = '',
  backdrop = false,
}) => {
  const popupType = React.useMemo(() => {
    switch (type) {
      case PopupType.ALERT:
        return 'alert';
      default:
        return '';
    }
  }, [type]);
  const { taskBar } = usePatientProfileSettings();
  const { showTask } = taskBar;
  const popupClassName = `popup-container ${type} ${className} ${showTask ? 'view-height-87' : ''}`;

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement={placement}
      className={popupClassName}
      backdrop={backdrop}
      onClick={(e) => e.stopPropagation()}
    >
      <Offcanvas.Header closeButton={false}>
        <button className="close-btn" onClick={onHide}>
          <X size={24} color="#654b78" />
        </button>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex gap-2 align-items-center">
          {titleIcon}
          <span className="popup-title">{title}</span>
        </div>
        {children}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CareMapprPopup;
